import { render } from "./poll.vue?vue&type=template&id=02c7de4c"
import script from "./poll.js?vue&type=script&lang=js"
export * from "./poll.js?vue&type=script&lang=js"

import "./poll.vue?vue&type=style&index=0&id=02c7de4c&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__